import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { RecipientRequestType } from '@/types/vendorVaultTypes';
import { REQUEST_STATUS_MAP } from '../const/const';

export const RecipientRequestStatus = ({ request }: { request: RecipientRequestType }) => (
  <StatusWrapper variant={REQUEST_STATUS_MAP[request.status]?.variant}>{request.status_label}</StatusWrapper>
);
